var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentProperty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4967_11771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1385 6.055V7.93917C10.1385 9.50834 9.50846 10.1383 7.93929 10.1383H6.05512C4.48596 10.1383 3.85596 9.50834 3.85596 7.93917V6.055C3.85596 4.48583 4.48596 3.85583 6.05512 3.85583H7.93929C9.51429 3.86167 10.1385 4.48583 10.1385 6.055Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8334 3.36585V5.25002C12.8334 6.81919 12.2034 7.44919 10.6342 7.44919H10.1384V6.06085C10.1384 4.49169 9.50842 3.86169 7.93925 3.86169H6.55091V3.36585C6.55091 1.79669 7.18092 1.16669 8.75008 1.16669H10.6342C12.2034 1.16669 12.8334 1.79669 12.8334 3.36585ZM1.16675 10.6342V8.75002C1.16675 7.18085 1.79675 6.55085 3.36591 6.55085H3.86175V7.93919C3.86175 9.50835 4.49175 10.1384 6.06092 10.1384H7.44925V10.6342C7.44925 12.2034 6.81925 12.8334 5.25008 12.8334H3.36591C1.79675 12.8334 1.16675 12.2034 1.16675 10.6342Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4967_11771"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentProperty);
export default __webpack_public_path__ + "static/media/payment-property.e3e998a0696b57f23e70ac16d4c242a2.svg";
export { ForwardRef as ReactComponent };